import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { JournalIntervalCumulativeDecisionSummary } from 'donor-elf-web/lib/journal-utils';

interface ComponentArgs {
  goalAmount: number;
  intervalSummaries: JournalIntervalCumulativeDecisionSummary[];
}

export default class JournalSummaryDecisionsMadeComponent extends Component<ComponentArgs> {
  @cached
  get decisionsMadeAmount(): number {
    if (this.args.intervalSummaries.length == 0) {
      return 0;
    }
    let last =
      this.args.intervalSummaries[this.args.intervalSummaries.length - 1];
    return last.cumulativeAmount;
  }

  get decisionsMadePercent(): number {
    return (this.decisionsMadeAmount * 100) / this.args.goalAmount;
  }
}
